var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationsIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3625 25.2459V20.9217H1.93938C0.71365 20.9217 0 20.2065 0 18.9782C0 13.3008 0 7.62335 0 1.9459C0 0.714113 0.710133 0.0012207 1.93821 0.0012207H28.07C29.2805 0.0012207 30 0.71762 30 1.92487C30 7.61244 30 13.3 30 18.9876C30 20.2124 29.284 20.9229 28.0512 20.9229H19.6527V25.247H19.9609C21.4163 25.247 22.8706 25.247 24.326 25.247C24.9963 25.247 25.4275 25.8512 25.1885 26.4414C25.1297 26.5977 25.0264 26.7334 24.8913 26.8318C24.7561 26.9302 24.5951 26.9871 24.4279 26.9954C24.3401 27.0001 24.2521 27.0001 24.1643 26.9954H5.82633C5.69977 27.0019 5.57288 26.9949 5.44783 26.9743C5.23426 26.9312 5.04427 26.8107 4.91446 26.6361C4.78464 26.4615 4.72418 26.2452 4.74474 26.0289C4.76882 25.8086 4.87537 25.6055 5.04307 25.4601C5.21078 25.3147 5.42729 25.2378 5.64938 25.2447C7.1048 25.2447 8.55904 25.2447 10.0144 25.2447L10.3625 25.2459ZM28.2212 19.1559V1.77878H1.77415V19.1559H28.2212ZM12.1413 25.2248H17.8563V20.9451H12.1413V25.2248Z",
    fill: "#F5F6FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsIconDark);
export default __webpack_public_path__ + "static/media/applications-icon-dark.e864f8e444de6d3b31a4fe4bc97611f9.svg";
export { ForwardRef as ReactComponent };